var toastElement = document.createElement('div');

toastElement.className = 'toast';

document.body.appendChild(toastElement);

window.showToast = function showToast(text, variant = 'info', time = 3000) {
  toastElement.innerHTML = text;
  toastElement.className = toastElement.className + ' toast--visible toast--' + variant;
  setTimeout(function() {
    toastElement.className = toastElement.className.replace(' toast--visible', '').replace(' toast--' + variant, '');
  }, time)
}